import { api } from "@/lib/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "../use-toast";
import { getAgenciesQueryOptions, getAgencyQueryOptions } from "./get.hooks";

export function useDeleteAgency(opts?: {
  onSuccess?: () => void;
  onError?: () => void;
}) {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (id: string) =>
      api.delete<void>(`/api/agencies/$id`, undefined, {
        pathReplace: { $id: id },
      }),
    onSuccess: (_, id) => {
      queryClient.setQueryData(getAgenciesQueryOptions.queryKey, (old) =>
        old?.filter((a) => a.id !== id),
      );
      queryClient.resetQueries({
        queryKey: getAgencyQueryOptions(id).queryKey,
      });
      toast({
        title: "toast.agencyDeleted",
        variant: "success",
      });
      opts?.onSuccess?.();
    },
    onError: () => {
      toast({
        title: "toast.deleteAgencyError",
        variant: "destructive",
      });
      opts?.onError?.();
    },
  });
}
